import { Navigate, Outlet } from "react-router-dom";
import { RoutesI } from "./PublicRoutes.routes";

const PrivateRoute = ({ token }: RoutesI) => {
  // Mock bypass is dev-only — never honoured on PRD even if the URL carries ?mock=1.
  const isMock =
    typeof window !== "undefined" &&
    process.env.REACT_APP_ENVIROMENT !== "PRD" &&
    new URLSearchParams(window.location.search).get("mock") === "1";
  if (isMock) return <Outlet />;
  return token ? <Outlet /> : <Navigate to={`/login${window.location.search}`} />;
};

export default PrivateRoute;
